// extracted by mini-css-extract-plugin
export default {"close-icon":"styles-module__close-icon___bb134f","closeIcon":"styles-module__close-icon___bb134f"};